import type { ReactNode } from 'react';

import { cn } from '../../lib/utils';

type TreeItemElementProps = {
  children: ReactNode;
  className?: string;
};

export function TreeItemElement({
  children,
  className,
}: TreeItemElementProps) {
  return (
    <div
      className={cn(
        'eye:min-w-0 eye:flex eye:flex-1 eye:items-start eye:gap-4xs',
        className,
      )}
    >
      {children}
    </div>
  );
}
